export const GET_ENTERPRISES = "GET_ENTERPRISES";
